<footer class="it-footer" [innerHTML]="htmlContent"></footer>


